import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DeleteDialogUI, FileTabUI, FormErrorUI, FormLabelUI, InputUI, TabsUI } from '../Interface';
import { Field, useFormikContext } from 'formik';
import ProjectTaskReportsTable from './ProjectTaskReportsTable';
import TaskListRespPersonTable from '../TaskList/TaskListRespPersonTable';
import Comments from '../Comment/Comments';

const DescriptionPanel = (props) => {
  const { viewField } = props;
  const { errors, values } = useFormikContext();
  return (
    <div>
      <div className="col-span-full relative">
        <Field
          type="text"
          name="description"
          as={InputUI}
          className="resize-none h-36, p-2"
          fullWidth
          label={<FormLabelUI text="Megjegyzés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.description} />}
          InputLabelProps={{ shrink: values.description && values.description !== '' }}
          multiline
          rows={4}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

const ProjectTaskTabs = (props) => {
  const { viewField, autocompleteOptions, selectedValues, setRefetchTable, disabled, addField, dialog } = props;
  const { setFieldValue, values } = useFormikContext();
  const [activeTab, setActiveTab] = useState(0);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      return file;
    });

    const existingAttachments = Array.isArray(values.taskListAttachment) ? values.taskListAttachment : [];

    setFieldValue('taskListAttachment', [...existingAttachments, ...filesWithId]);
  };

  const tabs = [
    {
      id: 1,
      name: 'Megjegyzés',
      content: <DescriptionPanel {...props} />,
    },
    {
      id: 2,
      name: 'További felelősök',
      content: <TaskListRespPersonTable {...props} disabled={viewField} autoCompleteOptions={autocompleteOptions} />,
    },
    {
      id: 3,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={values?.taskListAttachment ?? []}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          handleUpload={handleUpload}
          disabled={props.viewField}
        />
      ),
    },
    {
      id: 4,
      name: 'Lejelentések',
      content: <ProjectTaskReportsTable {...props} />,
    },
    {
      id: 5,
      name: 'Hozzászólások',
      content: (
        <Comments
          rows={selectedValues.comments ?? []}
          lineId={selectedValues.id}
          subMenuUrl="taskList"
          setRefetchTable={dialog ? dialog?.setTaskChanged : setRefetchTable}
          disabled={disabled || !addField}
        />
      ),
    },
  ];

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    setFieldValue(
      'taskListAttachment',
      (values.taskListAttachment || []).filter((taskListAttachment) => taskListAttachment.id !== fileToDelete.id)
    );

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div>
      <div className="px-2">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};

export default ProjectTaskTabs;
